/*
     Title: Constant for INCOMPLETE_TYPE
     Description: Constant for INCOMPLETE_TYPE
     Author: Iqbal Hossain
     Date: 06-January-2022
     Modified: 11-January-2022
*/

export const FETCH_INCOMPLETE_TYPE = 'FETCH_INCOMPLETE_TYPE';
export const TOGGLE_INCOMPLETE_TYPE_SIDEBAR = 'TOGGLE_INCOMPLETE_TYPE_SIDEBAR';
export const TOGGLE_INCOMPLETE_TYPE_STATUS = 'TOGGLE_INCOMPLETE_TYPE_STATUS';
export const FETCH_INCOMPLETE_TYPE_BY_QUERY = 'FETCH_INCOMPLETE_TYPE_BY_QUERY';
export const ADD_INCOMPLETE_TYPE = 'ADD_INCOMPLETE_TYPE';
export const DELETE_INCOMPLETE_TYPE = 'DELETE_INCOMPLETE_TYPE';
export const FETCH_INCOMPLETE_TYPE_BY_ID = 'FETCH_INCOMPLETE_TYPE_BY_ID';
export const UPDATE_INCOMPLETE_TYPE = 'UPDATE_INCOMPLETE_TYPE';
export const DELETE_INCOMPLETE_TYPE_BY_RANGE = 'DELETE_INCOMPLETE_TYPE_BY_RANGE';

/** Change Log
 * 11-Jan-2022(Iqbal): Add TOGGLE_INCOMPLETE_TYPE_SIDEBAR, FETCH_INCOMPLETE_TYPE_BY_QUERY, ADD_INCOMPLETE_TYPE, DELETE_INCOMPLETE_TYPE, FETCH_INCOMPLETE_TYPE_BY_ID, UPDATE_INCOMPLETE_TYPE, DELETE_INCOMPLETE_TYPE_BY_RANGE
 */
